import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1750.58824,1750.11765 L169.411765,1750.11765 C138.24,1750.11765 112.941176,1724.70588 112.941176,1693.64706 L112.941176,1398.08 L323.124706,1524.23529 L1596.87529,1524.23529 L1807.05882,1398.08 L1807.05882,1693.64706 C1807.05882,1724.70588 1781.76,1750.11765 1750.58824,1750.11765 Z M451.764706,1411.29412 L451.764706,168.941176 L1468.23529,168.941176 L1468.23529,1411.29412 L451.764706,1411.29412 Z M1750.58824,733.647059 L1581.17647,733.647059 L1581.17647,56 L338.823529,56 L338.823529,733.647059 L169.411765,733.647059 C76.0094118,733.647059 0,809.656471 0,903.058824 L0,1693.64706 C0,1787.04941 76.0094118,1863.05882 169.411765,1863.05882 L1750.58824,1863.05882 C1843.99059,1863.05882 1920,1787.04941 1920,1693.64706 L1920,903.058824 C1920,809.656471 1843.99059,733.647059 1750.58824,733.647059 Z M621.176471,488.903529 L1185.88235,488.903529 L1185.88235,375.962353 L621.176471,375.962353 L621.176471,488.903529 Z M621.176471,1166.55059 L1185.88235,1166.55059 L1185.88235,1053.60941 L621.176471,1053.60941 L621.176471,1166.55059 Z M621.176471,827.727059 L1298.82353,827.727059 L1298.82353,714.785882 L621.176471,714.785882 L621.176471,827.727059 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconInboxSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconInboxSolid, _Component);

  var _super = _createSuper(IconInboxSolid);

  function IconInboxSolid() {
    _classCallCheck(this, IconInboxSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconInboxSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconInbox",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconInboxSolid.displayName = "IconInboxSolid";
  return IconInboxSolid;
}(Component);

IconInboxSolid.glyphName = 'inbox';
IconInboxSolid.variant = 'Solid';
IconInboxSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconInboxSolid;
export { IconInboxSolid };